import { LogLevel } from '@azure/msal-browser';

const baseUrl = `${window.location.origin}`;

export const msalConfig = {
    auth: {
        clientId: '0bbcbac3-434f-404d-9870-f4cfd903531e',
        authority: 'https://hygiasotest.b2clogin.com/hygiasotest.onmicrosoft.com/B2C_1_signupsignin1',
        knownAuthorities: ['hygiasotest.b2clogin.com'],
        redirectUri: `${baseUrl}/unlock`,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false
        },
    },
};